module.exports = __webpack_public_path__ + "img/stock0.07496a9e.png";